import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSelector } from 'reselect';
import { AccountType, DocumentGroup } from 'constants/kyc';
import { FieldName } from './constants';

const select = state => state.kyc;

const selectFormState = state => select(state).formState;

const selectFormData = state => select(state).formData;

const selectPaymentsIdentityConfiguration = state => select(state).paymentsIdentityConfiguration;

export const getFormUiState = state => select(state).formState.uiState;
export const getFirstName = state => selectFormData(state).firstName || '';
export const getLastName = state => selectFormData(state).lastName || '';
export const getBirthdate = state => selectFormData(state).birthdate || '';
export const getGeneralError = (state, fieldName) => {
  return select(state).generalErrors.byName[fieldName] || undefined;
};
export const getApiErrors = state => select(state).apiErrors;
export const getAddress = state => selectFormData(state).address;
export const getPaymentsIdentityConfiguration = createSelector(selectPaymentsIdentityConfiguration, paymentsIdentityConfiguration => paymentsIdentityConfiguration);
export const getAccountType = state => {
  var _selectPaymentsIdenti;

  return (_selectPaymentsIdenti = selectPaymentsIdentityConfiguration(state)) === null || _selectPaymentsIdenti === void 0 ? void 0 : _selectPaymentsIdenti.accountType;
};
export const getIsFormDisabled = state => select(state).formState.isFormDisabled;
export const getRequiredFields = state => {
  var _selectPaymentsIdenti2;

  return (_selectPaymentsIdenti2 = selectPaymentsIdentityConfiguration(state)) === null || _selectPaymentsIdenti2 === void 0 ? void 0 : _selectPaymentsIdenti2.requiredFields;
};
export const getStatus = state => {
  var _selectPaymentsIdenti3;

  return (_selectPaymentsIdenti3 = selectPaymentsIdentityConfiguration(state)) === null || _selectPaymentsIdenti3 === void 0 ? void 0 : _selectPaymentsIdenti3.status;
};
export const getIsFormDirty = state => select(state).formState.isFormDirty;
export const getAgreementHint = state => {
  var _selectPaymentsIdenti4;

  return ((_selectPaymentsIdenti4 = selectPaymentsIdentityConfiguration(state)) === null || _selectPaymentsIdenti4 === void 0 ? void 0 : _selectPaymentsIdenti4.agreementHint) || '';
};
export const getIsLegalRepresentativeUbo = state => selectFormData(state).isLegalRepresentativeUbo;
export const getUbos = state => selectFormData(state).ubos;
export const getDocumentFieldConfigurations = state => {
  var _selectPaymentsIdenti5;

  return (_selectPaymentsIdenti5 = selectPaymentsIdentityConfiguration(state)) === null || _selectPaymentsIdenti5 === void 0 ? void 0 : _selectPaymentsIdenti5.documentFieldConfigurations;
};
export const getFormData = createSelector(selectFormData, getAccountType, getFirstName, getLastName, getBirthdate, getAddress, getIsLegalRepresentativeUbo, getUbos, getRequiredFields, (formData, accountType, firstName, lastName, birthday, address, isLegalRepresentativeUbo, ubos, requiredFields) => {
  const isUboRequired = requiredFields === null || requiredFields === void 0 ? void 0 : requiredFields.includes(FieldName.Ubo);
  const isBusinessAccount = accountType === AccountType.Business;

  if (isUboRequired && isBusinessAccount && isLegalRepresentativeUbo && address) {
    const firstUbo = (ubos === null || ubos === void 0 ? void 0 : ubos[0]) || {
      nationality: '',
      birthplaceCountry: '',
      birthplaceCity: ''
    };
    return _objectSpread(_objectSpread({}, formData), {}, {
      ubos: [_objectSpread(_objectSpread({}, firstUbo), {}, {
        firstName,
        lastName,
        birthday,
        address
      })]
    });
  }

  return formData;
});
export const getKycStatus = createSelector(getPaymentsIdentityConfiguration, configuration => {
  return configuration === null || configuration === void 0 ? void 0 : configuration.status;
});
export const getIdentityDocumentConfiguration = createSelector(getDocumentFieldConfigurations, documentFieldConfigurations => {
  var _documentFieldConfigu;

  return documentFieldConfigurations === null || documentFieldConfigurations === void 0 ? void 0 : (_documentFieldConfigu = documentFieldConfigurations.filter(_ref => {
    let {
      group
    } = _ref;
    return group === DocumentGroup.IdentityDocuments;
  })) === null || _documentFieldConfigu === void 0 ? void 0 : _documentFieldConfigu[0];
});
export const getSupportingDocumentsConfiguration = createSelector(getDocumentFieldConfigurations, documentFieldConfigurations => documentFieldConfigurations === null || documentFieldConfigurations === void 0 ? void 0 : documentFieldConfigurations.filter(_ref2 => {
  let {
    group,
    options
  } = _ref2;
  return group === DocumentGroup.SupportingDocuments && options.length === 1;
}));
export const getIsSupportingDocumentRequired = createSelector(getSupportingDocumentsConfiguration, getRequiredFields, (documentFieldConfigurations, requiredFields) => {
  var _requiredFields$filte;

  const supportingDocumentTypes = documentFieldConfigurations === null || documentFieldConfigurations === void 0 ? void 0 : documentFieldConfigurations.map(_ref3 => {
    let {
      options
    } = _ref3;
    return options === null || options === void 0 ? void 0 : options[0].type;
  });
  return !!(requiredFields !== null && requiredFields !== void 0 && (_requiredFields$filte = requiredFields.filter(field => supportingDocumentTypes === null || supportingDocumentTypes === void 0 ? void 0 : supportingDocumentTypes.includes(field))) !== null && _requiredFields$filte !== void 0 && _requiredFields$filte.length);
});
export const getHasUnknownApiErrorOccured = state => selectFormState(state).hasUnknownApiErrorOccured;